"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VLPTileContainer = exports.TileGrid = exports.TileContainer = exports.Heading = exports.Disclaimer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = _interopRequireDefault(require("../../packages/typography"));
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
const TileGrid = exports.TileGrid = _styledComponents.default.div`
  margin-bottom: 48px;
  scroll-margin-top: 80px;
  ${(0, _breakpoints.default)("tablet")} {
    scroll-margin-top: 95px;
  }
  [data-virtuoso-scroller] {
    height: 100vh;
  }
  [data-virtuoso-scroller] > div {
    position: relative!important;
  }
`;
const TileContainer = exports.TileContainer = _styledComponents.default.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  ${(0, _breakpoints.default)("tablet")} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${(0, _breakpoints.default)("mobile")} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const VLPTileContainer = exports.VLPTileContainer = (0, _styledComponents.default)(TileContainer)`
  grid-template-columns: repeat(1, 1fr);
  ${(0, _breakpoints.default)("desktop", "up")} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
const Heading = exports.Heading = _styledComponents.default.div`
  text-align: center;
  ${(0, _breakpoints.default)("tablet", "up")} {
    text-align: left;
  }
`;
const Disclaimer = exports.Disclaimer = _styledComponents.default.div`
  margin-bottom: 10px;
`;